import { Toast, Dialog, Notify } from 'vant'

/** 页面交互 */
// toast提示
var vshowToast = function (msg) {
	Toast({
		message: msg,
		duration: 1500
	})
}

// 显示加载信息
var vshowLoading = function (msg) {
	Toast.loading({
		mask: true,
		forbidClick: true,
		duration: 0,
		message: msg
	})
}

// 隐藏加载信息
var vhideLoading = function () {
	Toast.clear()
}

// 显示成功信息
var vshowSuccess = function (msg) {
	Toast.success({
		message: msg,
		duration: 2000
	})
}

// 显示错误信息
var vshowWarning = function (msg) {
	Toast.fail({
		message: msg,
		duration: 2000
	})
}

// Notify提示
var vNotify = function (msg, duration) {
	Notify({
		message: msg,
		duration: duration == 0 || duration ? duration : 1500
	});
}
var vNotifyClose = function () {
	Notify.clear()
}

// 确认框
var vconfirm = function(message, title) {
	return new Promise(function (resolve, reject) {
		Dialog.confirm({
			title: title ? title : '',
			message: message
		}).then(() => {
			resolve()
		}).catch(() => {
			reject()
		});
	})
}

export {
	vshowToast,
	vshowLoading,
	vhideLoading,
	vshowSuccess,
	vshowWarning,
	vNotify,
	vNotifyClose,
	vconfirm
}


//////////////////
// WEBPACK FOOTER
// ./static/js/phone/utility.js
// module id = null
// module chunks = 